import { render } from "./ProgramSection.vue?vue&type=template&id=3fc17785"
import script from "./ProgramSection.vue?vue&type=script&lang=js"
export * from "./ProgramSection.vue?vue&type=script&lang=js"

import "./ProgramSection.vue?vue&type=style&index=0&id=3fc17785&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__